module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/mv_heading-e667305ef82cdb68643d5397084d462f.png";